function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".icon_hidden_a{fill:#7f868f;}.icon_hidden_b{fill:#3f4448;opacity:0.1;}.icon_hidden_c{opacity:0.2;}.icon_hidden_d{fill:#fff;}.icon_hidden_e{fill:#e9eff4;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon_hidden_a",
  d: "M3.541,3.541A11.976,11.976,0,0,0,20.478,20.478a12.032,12.032,0,0,0,0-16.937A11.9,11.9,0,0,0,3.541,3.541Z",
  transform: "translate(0 0)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon_hidden_b",
  d: "M52.473,35.911a11.809,11.809,0,0,1,1.874,6.445A12.026,12.026,0,0,1,42.356,54.347a11.809,11.809,0,0,1-6.445-1.874A11.994,11.994,0,1,0,52.473,35.911Z",
  transform: "translate(-34.019 -34.019)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  className: "icon_hidden_c",
  transform: "translate(4.051 3.901)"
}, React.createElement("path", {
  className: "icon_hidden_d",
  d: "M80.563,77.719c-1.2,1.2-2.773,1.649-3.372.974-.674-.674-.225-2.173.974-3.372s2.773-1.649,3.447-.974C82.211,74.946,81.762,76.52,80.563,77.719Z",
  transform: "translate(-76.876 -74.032)"
}));

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(5.76 4.32)"
}, React.createElement("path", {
  className: "icon_hidden_e",
  d: "M123.437,93.374,118.71,99.52a1.408,1.408,0,0,1-2.251,0l-4.728-6.146a1.461,1.461,0,0,1,0-1.724l4.728-6.146a1.408,1.408,0,0,1,2.251,0l4.728,6.146A1.459,1.459,0,0,1,123.437,93.374Z",
  transform: "translate(-111.449 -84.867)"
}), React.createElement("path", {
  className: "icon_hidden_d",
  d: "M120.736,86.781a16.823,16.823,0,0,1-5.028,6.445,15.841,15.841,0,0,1-2.026,1.349l-1.951-2.623a1.461,1.461,0,0,1,0-1.724l4.728-6.146a1.408,1.408,0,0,1,2.251,0Z",
  transform: "translate(-111.449 -83.521)"
}));

var SvgHidden = function SvgHidden(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHidden, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hidden.33e5f33e.svg";
export { ForwardRef as ReactComponent };